import styled from 'styled-components';
import { LabelRegularBoldM, LabelRegularM } from '../../../styles/globals';

export const ParagraphCont = styled.div`
  display: flex;
  flex-flow: column nowrap;
  white-space: pre-wrap;

  &:last-of-type {
    margin: 0;
  }
`;

export const Title = styled(LabelRegularBoldM)`
  ${({ theme }) => `
    margin: 0 0 ${theme.layout.spacing.nano};
  `};
`;

export const Text = styled(LabelRegularM)`
  margin: 0;
`;
